import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const NOMBRES_POOL = [
  'Carmen',
  'Ximena',
  'Sofia',
  'Lucia',
  'Valeria',
  'Mariana',
  'Fernanda',
  'Beatriz',
  'Elena',
  'Raquel',
  'Monica',
];

const CIUDADES_POOL = [
  'Monterrey',
  'Guadalajara',
  'CDMX',
  'Puebla',
  'Queretaro',
  'Merida',
  'Tijuana',
  'Cancun',
  'Saltillo',
  'Veracruz',
];

const FALLBACK_PRODUCTOS = [
  'aceite esencial',
  'hidrolato de rosas',
  'mica cosmetica',
  'cera de soya',
  'activo botanico',
];

function randomItem(items) {
  if (!items || items.length === 0) return '';
  return items[Math.floor(Math.random() * items.length)];
}

const CURSOS_PRODUCTOS = [
  'el Kit de Velas de Soya',
  'el Curso de Velas de Soya',
];

function SocialProofPopup() {
  const { pathname } = useLocation();
  const isCursoVelas = pathname === '/cursos/velas-de-soya';

  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [productosPool, setProductosPool] = useState(FALLBACK_PRODUCTOS);
  const [data, setData] = useState({ nombre: '', ciudad: '', producto: '', tiempo: 1 });

  useEffect(() => {
    if (isCursoVelas) return;
    let cancelled = false;

    async function loadProductos() {
      const { data: productos } = await supabase.from('productos').select('nombre').limit(300);
      if (cancelled) return;

      const nombres = (productos || [])
        .map((item) => item?.nombre?.trim())
        .filter(Boolean);

      if (nombres.length > 0) {
        setProductosPool(nombres);
      }
    }

    loadProductos();
    return () => {
      cancelled = true;
    };
  }, [isCursoVelas]);

  const showRandomPopup = useMemo(
    () => () => {
      const pool = isCursoVelas ? CURSOS_PRODUCTOS : productosPool;
      setData({
        nombre: randomItem(NOMBRES_POOL),
        ciudad: randomItem(CIUDADES_POOL),
        producto: randomItem(pool),
        tiempo: Math.floor(Math.random() * 10) + 1,
      });

      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    },
    [productosPool, isCursoVelas]
  );

  useEffect(() => {
    const initialTimer = window.setTimeout(showRandomPopup, 5000);
    const repeatInterval = window.setInterval(showRandomPopup, 25000);

    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(repeatInterval);
    };
  }, [showRandomPopup]);

  if (dismissed) return null;

  return (
    <div
      className={`global-social-proof-popup ${visible ? 'is-visible' : 'is-hidden'}`}
      role={visible ? 'status' : undefined}
      aria-live={visible ? 'polite' : undefined}
      aria-hidden={!visible}
    >
      <button className="gsp-close" onClick={() => setDismissed(true)} aria-label="Cerrar">✕</button>
      <div className="gsp-badge">Actividad reciente</div>
      <p className="gsp-message">
        <strong>{data.nombre}</strong> de <strong>{data.ciudad}</strong>{' '}
        {isCursoVelas ? 'adquirió' : 'compro'}{' '}
        <strong>{data.producto}</strong>
      </p>
      <p className="gsp-time">hace {data.tiempo} min</p>
    </div>
  );
}

export default SocialProofPopup;
